import { DownOutlined, EyeOutlined, FileAddOutlined, ReadOutlined, RightOutlined, SyncOutlined, UploadOutlined } from '@ant-design/icons';
import { Badge, Breadcrumb, Button, Card, Col, Divider, Empty, Grid, Input,message, Modal, Pagination, Row, Select, Space, Tooltip, Typography, notification } from 'antd';
import React, { useEffect, useState, useCallback } from 'react';
import AreaGredientChartY from './Usercomp/AreaGredientChartY';
import DailyTradeTable from './Usercomp/DailyTradeTable';
import DailyTradeDescription from './Usercomp/DailyTradeDescription';
import SmallCalendar from './Usercomp/SmallCalender';
import { useDispatch, useSelector } from 'react-redux';
import { useDailyJournalMutation, useDeleteNoteMutation, useSaveNoteMutation } from '../slices/zerodhaApiSlice';
import { setDailyjournal } from '../slices/dailyjournalSlice';
import moment from 'moment-timezone';
import MyEditor from './Usercomp/MyEditor';
import DateRange from './global/comp/DateRange';
import TradeCalendar from './customeCalender';
import { useAssignStrategyMutation, useGetAllStrategyQuery } from '../slices/strategyApiSlice';
const strategies = [
  { value: "breakout", label: "Breakout Strategy" },
  { value: "scalping", label: "Scalping Strategy" },
  { value: "reversal", label: "Reversal Strategy" },
  { value: "swing", label: "Swing Strategy" }
];
const DailyJournalScreen = () => {
    moment.tz.setDefault("Asia/Calcutta|Asia/Kolkata");
    const { Title, Text } = Typography;
    const [showid, setShowid] = useState(0);
    const [api, contextHolder] = notification.useNotification();
    const { date } = useSelector((state) => state.date);
    const { darkmode } = useSelector((state) => state.darkmode);
    const { dailyjournal } = useSelector((state) => state.dailyjournal);
    const [data, setData] = useState([]);
    const [modeldata, setModeldata] = useState({});
    const [content, setContent] = useState("");
    const [title, setTitle] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const pageSize = 5; // Cards per page
    const newDate = new Date();
  const { data:strategies } = useGetAllStrategyQuery(); // fetch from RTK Query
  const [selectedStrategy, setSelectedStrategy] = useState(null);

  // Check if data exists and transform for AntD Select
  const strategyOptions = strategies?.data?.map((s) => ({
    value: s.id,      // strategy id
    label: s.name,    // strategy name
  })) || [];

    const [assignStrategy] = useAssignStrategyMutation();



    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();

    // Mutations for fetching and saving notes
    const [dailyJournal, { isLoading: isJournalLoading }] = useDailyJournalMutation();
    const [saveNote, { isLoading: isSaveNoteLoading }] = useSaveNoteMutation();
    const dispatch = useDispatch();
const[deleteNote]=useDeleteNoteMutation();
    // Fetching journal data with pagination
    const fetchJournal = useCallback(async (page = 1) => {
        try {
            const res = await dailyJournal({
                startDate: date.startDate,
                endDate: date.endDate,
                page,
                pageSize,
            }).unwrap();

            if (res && res.data) {
                setData(res.data.results || []); // Update state with the fetched data
                setTotalRecords(res.data.totalCount || 0); // Update total records for pagination
                dispatch(setDailyjournal(res.data)); // If needed for other states
            }
            
            console.log("daily..journal",res);
            
            
        } catch (err) {
            api.error({ message: err?.data?.message || err.error || err?.data?.error || err?.data?.error });
        }
    }, [dailyJournal, date, dispatch, api]);

    useEffect(() => {
        fetchJournal(currentPage);
    }, [currentPage, fetchJournal]); // Depend only on currentPage and fetchJournal

    
    // Sync modal content whenever `modeldata` changes
    useEffect(() => {
        if (modeldata) {
            setTitle(modeldata?.note?.title || "");
            setContent(modeldata?.note?.content || "");
        }
    }, [modeldata]);

    // Show modal with data
    const showModal = (data) => {
        setModeldata(data || {}); // If `data` is null, reset
        setIsModalOpen(true);
    };

    const handleOk = async () => {
        try {
            const trade_date = modeldata?._id;
            await saveNote({ title, content,trade_date,  strategy_id: selectedStrategy }).unwrap();
            api.success({ message: "Note Saved!" });
            resetModal();
            fetchJournal(currentPage);
        } catch (err) {
            api.error({ message: err?.data?.message || err.error || err?.data?.error || err?.data?.error });
        }
    };


    const handleCancel = () => {
        resetModal();
    };

    // Reset modal states for a clean start
    const resetModal = () => {
        setIsModalOpen(false);
        setModeldata({});
        setTitle("");
        setContent(""); // Reset content
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
const handleDeleteNote = async () => {
  if (!modeldata?._id) return;

  await deleteNote(modeldata._id );

  setTitle("");
  setContent("");
};


    return (
        <div>
            {contextHolder}
            <Title level={2}   style={{         fontFamily: 'Inter, sans-serif', }}><ReadOutlined /> Daily Journal</Title>
            {/* <Row  style={{padding: "20px", backgroundColor: darkmode ? "#141414" : "#FFF", borderRadius: "5px"}}>     */}
              {/* <Col flex={"auto"}>
                <Breadcrumb items={[{ title: 'Dashboard' }, { title: 'Daily Journal' }]} style={{marginBottom: "5px"}} />
                <Space direction="horizontal" style={{marginBottom: "10px"}}>
                  {!screens.lg ? (<DateRange/>):(<></>)}
                </Space>
              </Col> */}
              {/* <Col flex={"none"}>
                <Space direction={!screens.lg ? "vertical" : "horizontal"} style={{marginBottom: "10px"}}>
                  <Text type="secondary"><SyncOutlined/> Last import was: {  newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' + newDate.getDate()}</Text>
                  <Button type='primary' ghost><UploadOutlined/> Import Trades</Button>
                </Space>
              </Col>         */}
            {/* </Row> */}
            <Divider/>
            <Row gutter={[16, 24]} style={{ marginBottom: '10px' }}>
                <Col md={19} xs={24}>
                     {dailyjournal?.results?.length > 0 ? (
                        dailyjournal.results.map((dat, index) => ( 
                        // {data.length > 0 ? (
                        //     data.map((dat, index) => (

                            <Card
                                key={index}
                                bordered={false}
                                className="card_hover"
                                  style={{ marginBottom: '24px' }} // Add space here

                                extra={
                                    dat.note == null
                                        ? <Tooltip title="Add Note"><Button type="primary" shape="circle" onClick={() => showModal(dat)}><FileAddOutlined /></Button></Tooltip>
                                        : <Tooltip title="View Note"><Button type="dashed" shape="circle" onClick={() => showModal(dat)}><EyeOutlined /></Button></Tooltip>
                                }
                                title={
                                    <>
                                        <Button type="primary" shape="circle" onClick={() => setShowid(showid === index ? 0 : index)}>
                                            {showid === index ? <DownOutlined /> : <RightOutlined />}
                                        </Button>
                                        <Text> {moment(dat._id).format('ddd, D MMM, YYYY')} <Badge status="default" /></Text>
                                        <Text type={Number(parseFloat(dat.runningPnlArray.at(-1).pnl)).toFixed(2) > 0 ? "success" : "danger"}>
                                            Realised P&L ₹ {isJournalLoading ? [] : Number(parseFloat(dat.runningPnlArray.at(-1).pnl)).toFixed(2)}
                                        </Text>
                                    </>
                                }
                                loading={isJournalLoading}
                            >
                                <Row gutter={[16, 24]} style={{ marginBottom: '10px' }}>
                                    <Col md={8} xs={24}><AreaGredientChartY datal={isJournalLoading ? [] : dat.runningPnlArray} /></Col>
                                    <Col md={16} xs={24}><DailyTradeDescription data={dat} /></Col>
                                </Row>
                                {/* {showid === index && <Row><DailyTradeTable data={dat.trades} /></Row>} */}

                                {showid === index && (
  <Row style={{ paddingTop: "10px" }}>
    <DailyTradeTable data={dat.trades} />
  </Row>
)}

                            </Card>
                        ))
                    ) : (
                        <Card><Empty /></Card>
                    )}
                    {/* Pagination controls */}
                    <Pagination
                        current={currentPage}
                        pageSize={pageSize}
                        total={totalRecords}
                        onChange={handlePageChange}
                        style={{ textAlign: 'center', marginTop: '20px' }}
                    />
                </Col>
                <Col md={5} xs={24}>
                
                {/* <SmallCalendar  setDate={setData} setTotalRecords={setTotalRecords}/> */}
<SmallCalendar
  onDateChange={(selectedDate) => {
    const startDate = moment(selectedDate).startOf('day').toISOString();
    const endDate = moment(selectedDate).endOf('day').toISOString();

    dispatch(setData({ startDate, endDate }));
    fetchJournal(1); // Refetch for the new date range
  }}
/>
                
                </Col>
   

            </Row>
                                            {/* <Row gutter={[16, 24]} style={{ marginBottom: '10px'}}>

             <Col md={24} xs={24}>
  <Card title="Journal Calendar">
    <TradeCalendar
      journalData={dailyjournal?.results || []}
      onOpenNote={(data) => {
        setModeldata(data);
        setIsModalOpen(true); // opens MyEditor modal 
      }}
    />
  </Card>
</Col>
</Row> */}
            <Modal
            
                title={
                    <>
                        <Text>{moment(modeldata?._id).format('ddd, D MMM, YYYY')} <Badge status="default" /></Text>
                        <Text type={Number(parseFloat(modeldata?.runningPnlArray?.at(-1)?.pnl || 0)).toFixed(2) > 0 ? "success" : "danger"}>
                            Realised P&L ₹ {isJournalLoading ? [] : Number(parseFloat(modeldata?.runningPnlArray?.at(-1)?.pnl || 0)).toFixed(2)}
                        </Text>
                    </>
                }
                width={1000}
                open={isModalOpen}
                onOk={handleOk}
                confirmLoading={isSaveNoteLoading}
                onCancel={handleCancel}
            >
                <Row gutter={[16, 24]} style={{ marginBottom: '10px' }}>
                    <Col md={8} xs={24}><AreaGredientChartY datal={isJournalLoading ? [] : modeldata.runningPnlArray} /></Col>
                    <Col md={16} xs={24}><DailyTradeDescription data={modeldata} /></Col>
                </Row>
<Row justify="end" style={{ marginBottom: 10 }}>
  <Col xs={8} sm={8} md={8} lg={6} xl={4}>
    <Button
      danger
      block
      onClick={handleDeleteNote}
    >
      Delete Note
    </Button>
  </Col>
</Row>

                <Row>
                    <Input
                        type="text"
                        placeholder="Title"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        style={{ marginBottom: "10px" }}
                    />
                    {isModalOpen && <MyEditor setContent={setContent} initialContent={content} />} {/* Render only when modal is open */}
                </Row>
            </Modal>
        </div>
    );
};

export default DailyJournalScreen;





